'use client'

import { ListItem } from '~/components/component-library/List/components/ListItem'
import { ListCTA as ListCTAProps } from '~/components/component-library/List/types'

export const ListCTA = ({ label, ...rest }: ListCTAProps) => (
  <ListItem
    key="cta"
    content={<span className="select-none text-blue-500">{label}</span>}
    {...rest}
  />
)
